import lodash from "lodash";
import { TMenuItem } from "../types";

const parsePrice = (item: TMenuItem): number => {
    let finalPrice = 0;
    const itemHasSelectedOptions = Boolean(item.components && item.components.find(component => component.options.find(option => option.value)))
    if (item.components && (itemHasSelectedOptions || !item.basePrice)) {
        const requiredOrChosenComponents = item.components.filter(
            component => component.isBase || component.isRequired || component.options.find(option => option.value)
        )
        finalPrice = requiredOrChosenComponents.map(component => {
            if (component.options.find(option => option.value)) {
                return component.options.reduce((acc, option) => acc + option.value * option.price, 0)
            } else {
                return (lodash.sortBy(component.options, option => option.price))[0].price
            }
        })
            .reduce((acc, price) => acc + price, item.basePrice)

    } else {
        finalPrice = item.basePrice
    }
    return (item.orderCount || 1) * finalPrice
}

export default parsePrice;